import 'regenerator-runtime/runtime';
import { call, put, fork, select, takeEvery } from 'redux-saga/effects';
import * as constants from 'constants/redux/cottages';
import * as actions from 'actions/cottages';
import { parseError } from 'logic/helpers';
import api from 'api';

function* fetchCottagesRequest() {
  try {
    const data = yield call(api.fetchCottages.bind(null));
    yield put(actions.fetchCottagesSuccess({ data }));
  } catch (e) {
    if (e.status === 401) {
      yield [put(actions.fetchCottagesFailure({ error: {} }))];
    } else {
      yield put(
        actions.fetchCottagesFailure({
          error: {
            status: e.status,
            message: e.message,
            canTryAgain: true,
          },
        }),
      );
    }
  }
}

function* fetchStatsRequest(req) {
  try {
    const { id } = req.payload;
    const stats = yield select((state) => state.cottages.stats);
    if (!stats[id].total) {
      const data = yield call(api.fetchStats.bind(null, id));
      const { total, rows } = data;
      yield put(actions.fetchStatsSuccess({ total, rows, id }));
    } else {
      const { total, rows } = stats[id];
      yield put(actions.fetchStatsSuccess({ total, rows, id }));
    }
  } catch (e) {
    const { id } = req.payload;
    if (e.status === 401) {
      yield [put(actions.fetchStatsFailure({ id, error: {} }))];
    } else {
      yield put(actions.fetchStatsFailure({ id, ...parseError(e) }));
    }
  }
}

function* fetchCottagesTags() {
  try {
    const data = yield call(api.fetchCottagesTags.bind(null));

    yield put(actions.fetchCottagesTagsSuccess(data));
  } catch (e) {
    // console.error(e);
  }
}

export default [
  fork(takeEvery, constants.FETCH_COTTAGES_REQUEST, fetchCottagesRequest),
  fork(takeEvery, constants.FETCH_STATS_REQUEST, fetchStatsRequest),
  fork(takeEvery, constants.FETCH_COTTAGES_TAGS_REQUEST, fetchCottagesTags),
];
